import { gql } from '@graphql/__generated__';

export const GET_PENDING_ACTIVITIES = gql(/* GraphQL */ `
  query LeadDetailsPendingActivities(
    $where: activities_bool_exp!
    $limit: Int = 100
  ) {
    activities(where: $where, order_by: { created_at: desc }, limit: $limit) {
      id
      activity_type
      subject
      due_at
      start_date
      end_at
      created_at
      note
      assigned_to
      created_by
      lead_id
      lot_id
      buyer_lead_id
      user_id
      success
      done
      location
      activities_target_users {
        target_user_id
      }
    }
  }
`);

export const INSERT_ACTIVITY = gql(/* GraphQL */ `
  mutation LeadDetailsInsertActivity($object: activities_insert_input!) {
    insert_activities_one(object: $object) {
      id
      lead_id
    }
  }
`);

export const UPDATE_ACTIVITY = gql(/* GraphQL */ `
  mutation LeadDetailsUpdateActivity(
    $id: uuid!
    $set: activities_set_input!
    $targetUsers: [activities_target_users_insert_input!]!
    $updateTargetUsers: Boolean!
  ) {
    delete_activities_target_users(where: { activity_id: { _eq: $id } })
      @include(if: $updateTargetUsers) {
      affected_rows
    }
    update_activities_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
    insert_activities_target_users(objects: $targetUsers)
      @include(if: $updateTargetUsers) {
      affected_rows
    }
  }
`);

export const UPDATE_ACTIVITY_PINNED = gql(/* GraphQL */ `
  mutation UpdateActivityPinned($id: uuid!, $pinned: Boolean!) {
    update_activities_by_pk(
      pk_columns: { id: $id }
      _set: { pinned: $pinned }
    ) {
      id
      pinned
    }
  }
`);

export const COMPLETE_TASK = gql(/* GraphQL */ `
  mutation ActivityWorkflowDialogCompleteTask($id: uuid!, $success: Boolean!) {
    update_activities_by_pk(
      pk_columns: { id: $id }
      _set: { done: true, success: $success, done_at: "now()" }
    ) {
      id
    }
  }
`);
